import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { CryptoEffects } from './+state/crypto.effects';
import { cryptoFeature } from './+state/crypto.reducers';

export function provideCryptoDomain() {
  return makeEnvironmentProviders([provideState(cryptoFeature), provideEffects(CryptoEffects)]);
}
